//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapActions, mapGetters } from 'vuex'

import RequestButtons from './RequestButtons.vue'
import SupTaskChangedNotifyIcon from '../../components/SupTaskChangedNotifyIcon.vue'
import RequestAutoPriority from './RequestAutoPriority.vue'
import { getRequestRoles } from './Request.js'
import RequestBody from './RequestBody.vue'
import ReportContent from '../Report/ReportContent/ReportContent.vue'
import requestContentStore from './requestContentStore.js'

export default {
  name: 'Request',
  components: {
    RequestBody,
    RequestButtons,
    SupTaskChangedNotifyIcon,
    RequestAutoPriority,
    ReportContent
  },
  provide () {
    return { contentStoreModule: 'requestContent' }
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    requestInitial: {
      type: Object,
      default () {
        return {}
      }
    },
    requestTitle: {
      type: String,
      default () {
        return ''
      }
    },
    requestSubtitle: {
      type: String,
      default () {
        return ''
      }
    },
    taskStatus: {
      type: String,
      default: ''
    },
    isInitialize: {
      type: Boolean,
      default: false
    },
    isCreateAudit: {
      type: Boolean,
      default: false
    },
    requestRoles: {
      type: Object,
      default () {
        if (this.taskStatus === 'BS0') {
          return getRequestRoles(this.request, this.$store.getters.getUser, 'createRequestCard')
        } else {
          return {}
        }
      }
    },
    hasFinishReportCreatedOrEditing: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      requestContentOpen: false
    }
  },
  computed: {
    ...mapGetters({
      getDocumentScrollTop: 'getDocumentScrollTop'
    }),
    docsHeaderFixed: function () {
      return this.$store.getters.getUserSetting('ui.common.docsHeaderFixed', true)
    },
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    showMobileView: function () {
      return !!this.mobile
    }
  },
  watch: {
    'request.id': function (requestId) {
      this.initializeRequestContentSession(requestId)
    }
  },
  created: function () {
    if (!this.$store.state.requestContent) {
      this.$store.registerModule('requestContent', requestContentStore)
    }
    this.retainRequestContentInstance()
    this.initializeRequestContentSession(this.request && this.request.id)
  },
  mounted: function () {
    setTimeout(() => {
      const scrollRequestBody = this.$refs.scrollRequestBody
      if (scrollRequestBody) {
        scrollRequestBody.setScrollPosition('vertical', this.getDocumentScrollTop)
      }
      this.setDocumentScrollTop(0)
    }, 500)
  },
  destroyed: function () {
    if (this.requestContentNavigateTimer) {
      clearTimeout(this.requestContentNavigateTimer)
      this.requestContentNavigateTimer = null
    }
    if (!this.$store.state.requestContent) {
      return
    }
    this.releaseRequestContentInstance().then(() => {
      const requestContentState = this.$store.state.requestContent
      if (requestContentState && requestContentState.instancesCount === 0) {
        this.$store.unregisterModule('requestContent')
      }
    })
  },
  methods: {
    ...mapActions({
      setDocumentScrollTop: 'setDocumentScrollTop',
      initializeRequestContentSession: 'requestContent/initializeSession',
      retainRequestContentInstance: 'requestContent/retainInstance',
      releaseRequestContentInstance: 'requestContent/releaseInstance'
    }),
    saveRequestScrollPosition: function () {
      const scrollRequestBody = this.$refs.scrollRequestBody
      if (scrollRequestBody && typeof scrollRequestBody.getScrollPosition === 'function') {
        const scrollPosition = scrollRequestBody.getScrollPosition()
        this.setDocumentScrollTop(scrollPosition)
      }
    },
    restoreRequestScrollPosition: function () {
      const scrollRequestBody = this.$refs.scrollRequestBody
      if (scrollRequestBody && typeof scrollRequestBody.setScrollPosition === 'function') {
        scrollRequestBody.setScrollPosition('vertical', this.getDocumentScrollTop || 0)
      }
    },
    openRequestContent: function () {
      if (this.requestContentOpen) {
        return
      }
      if (!this.showMobileView) {
        this.saveRequestScrollPosition()
      }
      this.requestContentOpen = true
      if (!this.showMobileView) {
        this.$nextTick(() => {
          this.restoreRequestScrollPosition()
        })
      }
    },
    closeRequestContent: function () {
      if (!this.requestContentOpen) {
        return
      }
      if (!this.showMobileView) {
        this.saveRequestScrollPosition()
      }
      this.requestContentOpen = false
      if (!this.showMobileView) {
        this.$nextTick(() => {
          this.restoreRequestScrollPosition()
        })
      }
    },
    onRequestContentNavigate: function (sectionId) {
      if (this.requestContentNavigateTimer) {
        clearTimeout(this.requestContentNavigateTimer)
      }
      if (this.showMobileView) {
        this.requestContentOpen = false
      }
      this.$nextTick(() => {
        this.requestContentNavigateTimer = setTimeout(() => {
          this.requestContentNavigateTimer = null
          const el = document.getElementById(sectionId)
          if (!el) {
            return
          }
          const scrollArea = this.$refs.scrollRequestBody
          if (
            scrollArea &&
            typeof scrollArea.getScrollTarget === 'function' &&
            typeof scrollArea.setScrollPosition === 'function'
          ) {
            const container = scrollArea.getScrollTarget()
            if (container) {
              const offset = container.scrollTop +
                el.getBoundingClientRect().top -
                container.getBoundingClientRect().top
              scrollArea.setScrollPosition('vertical', Math.max(0, offset), 300)
              return
            }
          }
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 450)
      })
    },
    onStartSaveChanges: function () {
      const scrollRequestBody = this.$refs.scrollRequestBody
      if (scrollRequestBody) {
        const scrollPosition = scrollRequestBody.getScrollPosition()
        this.setDocumentScrollTop(scrollPosition)
      }
    },
    onCloseTask: function () {
      this.$emit('close')
    },
    onTaskCreated: function (event) {
      this.$emit('task-created', event)
    },
    onTaskUpdated: function () {
      this.$emit('task-updated', event)
    },
    selectExecutor () {
      const requestExecutorComponent = this.$refs.refRequestBody ? this.$refs.refRequestBody.$refs.requestExecutor : null
      if (requestExecutorComponent) {
        requestExecutorComponent.showProposedExecutors()
      }
    }
  }
}

